// CSS owns the breakpoints; move the same nodes into balanced column lists.
const layouts = new WeakMap()

function arrangePeopleLists () {
    document.querySelectorAll('[data-people-preview-list]').forEach(wrapper => {
        let state = layouts.get(wrapper)
        if (!state) {
            state = {
                people: Array.from(wrapper.querySelectorAll('.people-preview-list__person')),
                columns: 0
            }
            layouts.set(wrapper, state)
        }

        const requested = parseInt(getComputedStyle(wrapper).getPropertyValue('--people-columns'), 10) || 1
        const columns = Math.min(requested, state.people.length)
        if (!columns || columns === state.columns) return

        const focused = wrapper.contains(document.activeElement) ? document.activeElement : null
        const fragment = document.createDocumentFragment()
        const perColumn = Math.floor(state.people.length / columns)
        const remainder = state.people.length % columns
        let offset = 0

        for (let column = 0; column < columns; column++) {
            const list = document.createElement('ul')
            list.className = 'people-preview-list__column'
            const size = perColumn + (column < remainder ? 1 : 0)
            state.people.slice(offset, offset + size).forEach(person => list.appendChild(person))
            fragment.appendChild(list)
            offset += size
        }

        wrapper.replaceChildren(fragment)
        state.columns = columns
        // Moving a focused link can blur it; preserve keyboard navigation on resize.
        if (focused) focused.focus({ preventScroll: true })
    })
}

let resizeFrame
window.addEventListener('resize', () => {
    cancelAnimationFrame(resizeFrame)
    resizeFrame = requestAnimationFrame(arrangePeopleLists)
})
document.addEventListener('htmx:afterSwap', arrangePeopleLists)
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrangePeopleLists)
} else {
    arrangePeopleLists()
}
